<template>
    <div class="content-container-white">
        <div class="container"><ModuleHeader title="Project erstellen">

        </ModuleHeader>

        <div v-if="error" class="error">
            <div class="mb-4">{{ error }}</div>
            <button type="button" class="btn btn-primary" @click="$router.go(-1)">Zurück</button>
        </div>

        <div v-if="saveError" class="error">
            <div class="mb-4">{{ saveError }}</div>
            <button type="button" class="btn btn-primary" @click="$router.go(-1)">Zurück</button>
        </div>


        <div v-if="customers && !error && !saveError">
            <form @submit.prevent="createProject" class="default-form">
                <div class="form-group">
                    <label for="projectName">Name*</label>

                    <b-form-input id="projectName"
                                  autocomplete="off"
                                  :state="checkState('projectName')"
                                  type="text"
                                  v-validate="'required'"
                                  name="projectName"
                                  v-model.trim="project.name"
                                  ref="projectName"
                    ></b-form-input>
                    <span v-show="errors.has('projectName')" class="error-message">Projekname ist ein Pflichtfeld</span>

                </div>

                <div class="form-group">
                    <label for="inputCustomer">Kunde*</label>

                    <b-form-select
                            v-model="project.customerId"
                            :options="customers"
                            :state="checkState('inputCustomer')"
                            v-validate="'required'"
                            id="inputCustomer" name="inputCustomer"/>

                    <span v-show="errors.has('inputCustomer')" class="error-message">Kunde ist ein Pflichtfeld</span>
                </div>

                <div class="form-group">
                    <label for="textAreaDescription">Beschreibung*</label>
                    <b-form-textarea id="textAreaDescription"
                                     v-model="project.description"
                                     :rows="4"
                                     :max-rows="6"
                                     name="textAreaDescription"
                                     v-validate="'required'"
                                     :state="checkState('textAreaDescription')"
                    >
                    </b-form-textarea>

                    <quill-editor v-model="content"
                                  ref="myQuillEditor"
                                  :options="editorOption"
                                  @blur="onEditorBlur($event)"
                                  @focus="onEditorFocus($event)"
                                  @ready="onEditorReady($event)">
                    </quill-editor>
                    <span v-show="errors.has('textAreaDescription')" class="error-message">Du musst das Projekt beschreiben</span>
                </div>

                <b-form-group label="Projekttyp" class="mt-5">
                    <b-form-radio-group id="radiosProjectType"
                                        v-model="projectType"
                                        :options="projectTypes"
                                        name="radiosProjectType"
                                        v-validate="'required'"
                    >
                    </b-form-radio-group>
                    <span v-show="errors.has('radiosProjectType')" class="error-message">Projekttyp ist ein Pflichtfeld</span>
                </b-form-group>

                <div class="form-group" v-show="projectType">

                    <div class="form-row">
                        <div class="col-md-6" v-show="projectType === 'timeandmaterial' || projectType === 'hoursamount'">
                            <label for="hourrate">Stundenpreis*</label>
                            <input type="number" class="form-control" id="hourrate" aria-describedby="hourrate"
                                   v-model="project.hourrate"
                                   autocomplete="off"
                            >
                        </div>

                        <div class="col-md-6" v-show="projectType === 'hoursamount'">
                            <label for="houramount">Stundenanzahl*</label>
                            <input type="number" class="form-control" id="houramount" aria-describedby="houramount"
                                   v-model="project.houramount"
                                   autocomplete="off"
                            >
                        </div>

                        <div class="col-md-6" v-show="projectType === 'fixedprice'">
                            <label for="fixedprice">Fixer Preis*</label>
                            <input type="number" class="form-control" id="fixedprice" aria-describedby="fixedprice"
                                   v-model="project.fixedprice"
                                   autocomplete="off"
                            >
                        </div>
                    </div>
                </div>

                <div class="form-bottom-buttons d-flex justify-content-end mt-5">
                    <b-form-checkbox id="checkbox1"
                                     v-model="createAnother"
                                     value="true"
                                     unchecked-value="false">
                        weitere Erstellen
                    </b-form-checkbox>
                    <button type="submit" class="btn btn-success">Hinzufügen</button>
                    <button type="button" class="btn btn-link" @click="$router.go(-1)">Abbrechen</button>
                </div>
            </form>
        </div></div>
    </div>
</template>

<script>
    import ModuleHeader from "components/util/ModuleHeader";
    import firestore from "firedb/init";
    import firebase from 'firebase/app';
    import slugify from "slugify";
    import xxx from 'components/project/JiraTaskViewer';

    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'

    import { quillEditor } from 'vue-quill-editor'

    export default {
        name: "ProjectCreate",

        components: {ModuleHeader, xxx, quillEditor},
        data: function() {
            return {
                createAnother: false,
                project: {
                    name: null,
                    customerId: null,
                    description: null,
                    type: null,
                    hourrate: 65,
                    houramount: 0,
                    fixedprice: 0,
                    billedamount: 0,
                    usedHours: []
                },

                projectTypes: [
                    { text: 'Time and Material', value: 'timeandmaterial' },
                    { text: 'Pauschale', value: 'fixedprice' },
                    { text: 'Stundenkontingent', value: 'hoursamount'}
                ],
                projectType: null,
                saveError: null,
                error: null,
                customers: null,

                content: '<h2>I am Example</h2>',
                editorOption: {
                    // some quill options
                }
            }
        },
        methods: {


            onEditorBlur(quill) {
                console.log('editor blur!', quill)
            },
            onEditorFocus(quill) {
                console.log('editor focus!', quill)
            },
            onEditorReady(quill) {
                console.log('editor ready!', quill)
            },
            onEditorChange({ quill, html, text }) {
                console.log('editor change!', quill, html, text)
                this.content = html
            },

            checkState(fieldName) {

                if (!this.errors.has(fieldName)) {
                    return null;
                }

                return false;
            },

            sendToFirebase() {
                return firestore.collection('project').add({
                    name: this.project.name,
                    slug: slugify(this.project.name, {
                        replacement: '-',
                        remove: /[$*_+~.()'"!\-:@#]/g,
                        lower: true
                    }),
                    customerId: this.project.customerId,
                    customer_name: this.project.customer_name,
                    description: this.project.description,
                    status: 'created',
                    type: this.project.type,
                    hourrate: +this.project.hourrate,
                    houramount: +this.project.houramount,
                    fixedprice: +this.project.fixedprice,
                    usedHours: this.project.usedHours,
                    billedamount: this.project.billedamount,
                    user: {
                        email: firebase.auth().currentUser.email,
                        uid: firebase.auth().currentUser.uid
                    },
                    createDate: this.$moment().format(),
                });
            },
            createProject() {

                if(this.createAnother) {
                    this.createProjectAndAddNew();
                } else {
                    this.$validator.validateAll().then(valid => {

                        if (valid) {
                            this.project.customer_name = this.customers.filter(x => x.value === this.project.customerId)[0].text;

                            this.sendToFirebase().then(result => {

                                this.$router.replace('/app/project');
                            }).catch(e => {
                                console.error(e);
                                this.saveError = "Projekt konnte nicht erstellt werden."
                            });
                        }
                    });
                }
            },

            createProjectAndAddNew() {

                this.$validator.validateAll().then(valid => {

                    if (valid) {

                        this.project.customer_name = this.customers.filter(x => x.value === this.project.customerId)[0].text;

                        this.sendToFirebase().then(result => {

                            this.project = {
                                name: null,
                                customerId: null,
                                description: null,
                                type: null,
                                hourrate: 65,
                                houramount: 0,
                                fixedprice: 0,
                                billedamount: 0,
                                usedHours: []
                            };
                            this.projectType = null;

                            this.$refs.projectName.focus();
                        }).catch(e => {
                            console.error(e);
                            this.saveError = "Projekt konnte nicht erstellt werden."
                        });
                    }
                });
            }
        },

        created() {

            //TODO change to Promise.all
            firestore.collection('customer').get()
                .then(snapshot => {

                    if (snapshot.size === 0) {
                        return Promise.reject('Keine Kunden gefunden');
                    }

                    this.customers = [];

                    snapshot.forEach(doc => {
                        let customer = doc.data();
                        customer.id = doc.id;

                        this.customers.push(customer);
                    });

                    this.customers = this.customers.map(c => {
                        return {text: c.name, value: c.id}
                    });
                })
                .catch((e) => {
                    console.error(e);
                    this.error = 'Für die Erstelleung eines Projektes notwendige Daten konnten nicht geladen werden.'
                });
        },

        watch: {

            projectType: function(val) {

                this.project.type = val;
            }
        },

        computed: {
            editor() {
                return this.$refs.myQuillEditor.quill
            }
        },
    }
</script>

<style scoped lang="scss">

    .buttons {
        margin-top: 2rem;
    }
</style>